import React from 'react';

const Help = () => {
    return (
        <div className="space-y-6">
            <div className="border-b pb-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Service Reminders</h3>
                <p className="text-sm text-gray-600">
                    Stay on top of vehicle maintenance with automated service alerts.
                </p>
            </div>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Due Dates and Thresholds</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li><strong>Due Date:</strong> The scheduled time for the maintenance task.</li>
                    <li><strong>Status:</strong> Monitor if a reminder is Pending, Overdue, or Resolved.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Managing Alerts</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Use <strong>Date Range Picker</strong> to view upcoming or past reminders.</li>
                    <li>Search by vehicle name to see all maintenance scheduled for a specific unit.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Exporting Lists</h4>
                <p className="text-sm text-gray-600">
                    Download your service schedule as a <strong>PDF</strong> or <strong>CSV</strong> to share with your maintenance team.
                </p>
            </section>
        </div>
    );
};

export default Help;
